import { render } from "./ActieModule.vue?vue&type=template&id=81cbd5cc"
import script from "./ActieModule.vue?vue&type=script&lang=js"
export * from "./ActieModule.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__